import React from 'react';
import { Popover, Box, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

export const getFieldName = (name, get) => {
  if (name.includes('||')) {
    var full = name.split('||');
    var lable = full[0];
    var info = full[1];
    return get === 'label' ? lable : info;
  } else {
    return name;
  }
};

export const ShowFieldWithInfo = ({ name }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {name.includes('||') ? (
        <>
          <span style={{ paddingLeft: 4, paddingRight: 4 }}>
            <InfoIcon onClick={handlePopoverOpen} />
          </span>
          <Popover
            id="mouse-over-popover"
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Box p={2}>
              <Typography>{getFieldName(name)}</Typography>
            </Box>
          </Popover>
        </>
      ) : null}
    </>
  );
};
